import errors from './components/errors/ru';
import common from './components/common/ru';
import guest from './components/guest/ru';
import menu from './components/menu/ru';
import settings from './components/settings/ru';
import filters from './components/filters/ru';
import forms from './components/forms/ru';
import modals from './components/modals/ru';
import xml from './components/xml/ru';
import notifications from './components/notifications/ru';

import documents from './views/documents/ru';
import approvals from './views/approvals/ru';
import request from './views/request/ru';
import project from './views/project/ru';
import worksheet from './views/worksheet/ru';
import person from './views/person/ru';
import user from './views/user/ru';
import events from './views/events/ru';
import calendar from './views/calendar/ru';
import notdone from './views/notdone/ru';
import company from './views/company/ru'
import education from './views/education/ru';
import metro from './metro/ru';

export default {
    ...documents,
    ...errors,
    ...common,
    ...guest,
    ...menu,
    ...approvals,
    ...request,
    ...project,
    ...worksheet,
    ...settings,
    ...filters,
    ...forms,
    ...person,
    ...user,
    ...modals,
    ...xml,
    ...events,
    ...notifications,
    ...calendar,
    ...notdone,
    ...company,
    ...education,
    ...metro
};
